import { makeAutoObservable } from "mobx";
import { EntityRepository } from "./entity_repository";
import { SyncManager } from "./sync_manager";
import { BaseStreamConsumer } from "./stream_consumer/base";
import { SSEStreamConsumer } from "./stream_consumer/sse";


export interface StreamEndpointConsumerOpts {
    consumerType: "SSE";
    url?: string;
    authToken?: string;
    args?: string;
}


export class StreamEndpoint {
    consumerOpts?: StreamEndpointConsumerOpts;
    consumer: BaseStreamConsumer | null = null;
    syncManager: SyncManager | null = null;
    repositories: {[key: string]: EntityRepository<any>}

    constructor(repositories: {[key: string]: EntityRepository<any>}, consumerOpts?: StreamEndpointConsumerOpts) {
        makeAutoObservable(this, {consumer: false, syncManager: false, repositories: false});
        this.repositories = repositories;
        this.consumerOpts = consumerOpts;
    }

    updateConsumerOpts(consumerOpts: Partial<StreamEndpointConsumerOpts>) {
        this.consumerOpts = Object.assign({}, this.consumerOpts, consumerOpts);
    }

    start() {
        if (!this.consumer) {
            if (!this.consumerOpts) {
                throw("Consumer options are not set");
            }
            if (!this.consumerOpts.authToken) {
                throw("Auth token is not set for SSEConsumer");
            }
            this.consumer = new SSEStreamConsumer(this.consumerOpts.url!, {"token": this.consumerOpts.authToken!}, this.repositories);
            this.syncManager = new SyncManager(this.consumerOpts.url!, {"Authorization": this.consumerOpts.authToken!}, this.repositories);
            this.consumer.start();
            this.syncManager.start();
        }
    }

    stop() {
        if (this.consumer) {
            this.consumer.stop();
            this.consumer = null;
        }
        if (this.syncManager) {
            this.syncManager.stop();
            this.syncManager = null;
        }
    }

    get isInitialized() {
        return this.consumer && this.consumer.isInitialized;
    }

    get isSyncing() {
        return this.syncManager && this.syncManager.isSyncing;
    }
}
